import request from '../utils/request.js'

// 获取指定时间段在班医生列表
export function getReservationDoctor(params) {
    return request({
        url: '/user-service/app/reservation/doctor',
        method: 'get',
        params
    })
}

// 新增预约
export function saveReservation(data) {
    return request({
        url: '/user-service/app/reservation/add',
        method: 'post',
        data
    })
}

// 编辑预约
export function editReservation(data) {
    return request({
        url: '/user-service/app/reservation/edit',
        method: 'post',
        data
    })
}

// 取消预约
export function cancelReservation(data) {
    return request({
        url: `/user-service/app/reservation/cancel/${data.id}`,
        method: 'post',
        data
    })
}

// 预约列表
export function getReservationList(data) {
    return request({
        url: '/user-service/app/askinfo/askList',
        method: 'post',
        data
    })
}